import { filter, pipe, prop } from 'rambda'
import { getRandomItemUnique, pluckFlat } from '@utils/collections'

// TODO: move out of front-end as it's already implemented in the back-end
export default (laptop, articleTopic, currentSubtitle) => {
  const phrasesSelected = pipe(
    getLaptopSubtitleOptions,
    filter(prop('condition')),
    pluckFlat('phrases'),
  )(laptop, articleTopic)

  return getRandomItemUnique(phrasesSelected, currentSubtitle)
}

const getLaptopSubtitleOptions = (laptop, articleTopic) => {
  const {
    bucketIndex,
    bucketPrice,
    memoryScore,
    weightScore,
    screenScore,
    graphicsScore,
    computingScore,
    batteryScore,
    storageScore,
    totalScoreNth,
    valueScore,
    screen,
  } = laptop

  return [
    {
      condition: (totalScoreNth === 1),
      phrases: [
        'The best gaming laptop',
        'The gaming laptop to beat',
      ],
    },
    {
      condition: (batteryScore > 7),
      phrases: ['Laptop with great battery life'],
    },
    {
      condition: (batteryScore > 6 &&
                graphicsScore >= 6 &&
                computingScore >= 6),
      phrases: ['Best balance of portability and gaming power'],
    },
    {
      condition: (computingScore >= 7 &&
                graphicsScore >= 7 &&
                memoryScore >= 7),
      phrases: ['High-end gaming laptop'],
    },
    {
      condition: (computingScore >= 5 &&
                computingScore < 7 &&
                graphicsScore >= 5 &&
                graphicsScore < 7),
      phrases: [
        'Laptop for playing modern games',
        'The best mid-range gaming laptop',
      ],
    },
    {
      condition: (weightScore > 7),
      phrases: [
        'One of the best laptops for users on the go',
        'Power and performance in a compact form',
      ],
    },
    {
      condition: (weightScore > 7 &&
                computingScore > 6 &&
                graphicsScore > 6),
      phrases: [
        'The best lightweight laptop for gamers',
      ],
    },
    {
      condition: (weightScore > 7 &&
                computingScore < 5 &&
                graphicsScore < 5),
      phrases: [
        'A good lightweight laptop if portability is more important than power',
      ],
    },
    {
      condition: (weightScore > 7 &&
                computingScore < 5 &&
                graphicsScore < 5),
      phrases: ['Ultra slim notebook that can handle light gaming'],
    },
    {
      condition: (screenScore > 5 &&
                screenScore < 7),
      phrases: ['Solid image quality'],
    },
    {
      condition: (screenScore >= 7),
      phrases: ['Insane image quality'],
    },
    {
      condition: (storageScore > 6),
      phrases: ['Forget about shortage of storage'],
    },
    {
      condition: (bucketIndex === 0 && bucketPrice),
      phrases: [`Best laptop for ${articleTopic} under $${bucketPrice}`],
    },
    {
      condition: (bucketIndex === 0 && bucketPrice),
      phrases: [`Best laptop for ${articleTopic} under $${bucketPrice}`],
    },
    {
      condition: (valueScore >= 65 && valueScore < 75),
      phrases: [
        'Laptop with solid price and performance ratio',
        'Good price-to-performance ratio',
        'Great value',
        'Well-rounded laptop',
      ],
    },
    {
      condition: (screen && screen.toLowerCase().includes('oled')),
      phrases: ['Gaming never looked better on this OLED display'],
    },
    {
      condition: (valueScore >= 75),
      phrases: [
        'Laptop with insane price and performance ratio',
        'Fantastic value',
        'Great value',
        'Plenty of features for the money',
      ],
    },
    {
      condition: true,
      phrases: [`${articleTopic} laptop ${bucketPrice ? `under $${bucketPrice}` : ''}`],
    },
  ]
}
